import React from "react";
import { InputWithHelpersFloatingLabel } from "./Shared";

export function InputDisabled({ label, value }) {
  return (
    <InputWithHelpersFloatingLabel
      type="text"
      label={label}
      id={label}
      value={value}
      helpers={[]}
      disabled={true}
    />
  );
}
